import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Animate from 'rc-animate';
import _ from 'lodash';
import styles from './Message.scss';
import chainFunc from '../../utils/chainFunc';
import MessageItem from './MessageItem';

export const messagePrefix = 'message';

function getKey() {
  let level = 1;
  return () => {
    const now = +new Date();
    return `${messagePrefix}-${now}-${level++}`;
  };
}

class Message extends Component {
  static propTypes = {
    containerClass: PropTypes.string,
    containerStyle: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
    };
  }

  componentDidMount() {
    this.getKey = getKey();
  }

  addMessage = (message = {}) => {
    // eslint-disable-next-line no-param-reassign,no-multi-assign
    const key = message.key = message.key || this.getKey();
    this.setState((prevState) => {
      const { messages } = prevState;
      // 如果key唯一，则添加
      if (messages.findIndex(msg => msg.key === key) === -1) {
        return {
          messages: messages.concat(message),
        };
      }
      return null;
    });
    return message;
  };

  removeMessage = (key) => {
    this.setState((prevState) => {
      return {
        messages: prevState.messages.filter(msg => msg.key !== key),
      };
    });
  };

  getItems = () => {
    const { messages } = this.state;
    return messages.map((msg) => {
      const { onClose, key } = msg;
      const closeFunc = chainFunc(this.removeMessage.bind(this, msg.key), onClose);
      return (
        <MessageItem {...msg} onClose={closeFunc} key={key}/>
      );
    });
  };

  render() {
    const { containerClass, containerStyle } = this.props;
    const containerCls = classNames({
      [`${styles[`${messagePrefix}-wrap`]}`]: true,
      [containerClass]: !!containerClass,
    });

    return (
      <Animate className={containerCls} style={containerStyle} transitionName={'move-up'}>
        {this.getItems()}
      </Animate>
    );
  }
}

Message.createInstance = (options = {}, callback) => {
  const { getContainer, ...msgProps } = options;
  let called = false;
  let target;
  if (_.isFunction(getContainer)) {
    target = getContainer();
  } else {
    target = document.createElement('div');
    document.body.appendChild(target);
  }

  function ref(instance) {
    if (called) {
      return;
    }
    called = true;
    const msgInstance = {
      add(msg) {
        return instance.addMessage(msg);
      },
      remove(key) {
        return instance.removeMessage(key);
      },
      destroy(_target = target) {
        ReactDOM.unmountComponentAtNode(_target); // _target是其他element
        document.body.removeChild(_target);
      },
      instance,
      target,
    };
    callback(msgInstance);
  }

  // 保证render的时候，可以准确获取到组件实例
  ReactDOM.render(<Message {...msgProps} ref={ref}/>, target);
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/Message/Message.js